import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  // align-items: center;
  flex-direction: column;
  // max-width: 1370px;
  margin: auto;
  // height: 100%;
  // justify-content: center;
`
